
import i18n from '@/i18n'
export default [
  {
    path: '/domainManage',
    meta: {
      title: i18n.t('menu.domainManagement') ,
      leftMenuCode: 'Configurations',
      leftActiveIndex: '/domainManage'
    },
    component: () => import('@/views/domainManage/index.vue')
  },
  {
    path: '/domainManage/add',
    meta: {
      title: i18n.t('website.createDomain'),
      leftMenuCode: 'Configurations',
      backable: true,
      leftActiveIndex: '/domainManage'
    },
    component: () => import('@/views/domainManage/add/index.vue')
  },
  {
    path: '/domainManage/multiDomain/accelerationConfig',
    meta: {
      title: i18n.t('domainManage.batchModifyAccelerationConfig'),
      leftMenuCode: 'Configurations',
      backable: true,
      leftActiveIndex: '/domainManage',
      customHeader: true
    },
    component: () => import('@/views/domainManage/multiDomain/accelerationConfig.vue')
  },
  {
    path: '/domainManage/multiDomain/domainConfig',
    meta: {
      title: i18n.t('domainManage.batchModifyDomainConfig'),
      leftMenuCode: 'Configurations',
      backable: true,
      leftActiveIndex: '/domainManage',
      customHeader: true
    },
    component: () => import('@/views/domainManage/multiDomain/domainConfig.vue')
  }
]